import { useEffect, useState } from 'react';
import styles from './NamespaceSearchModal.module.css';
import EmptyModal from '../EmptyModal';
import toUpperFirstCase from '../../utils/toUpperFirstCase';
import useApi from '../../services/useApi';
import searchValue from '../../utils/searchValue';

export default function NamespaceSearchModal({onClose}){
  const [nsSearchData,setNsSearchData]=useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [isInputClear,setIsInputClear]=useState(false);
  const [isList,setIsList]=useState(false);
  const [inputValue,setInputValue]=useState(null);
  const [requestedNs,setRequestedNs]=useState([]);

  useEffect(()=>{
    refreshNsAllList();
  },[])

  const refreshNsAllList=()=>{
    useApi.get('ngp/namespace/all/list').then((res)=>{
      setNsSearchData(res.data);
    })
  }

  const handleInputChange=(event)=>{
    setInputValue(event.target.value);

    if(event.target.value.trim()===""){
      setSearchResults([]);
      setIsInputClear(false);
      setIsList(false);
      return;
    }

    if(event.target.value.trim()!==""){
      setIsInputClear(true);
      setIsList(true);
    }

    setSearchResults(searchValue(nsSearchData,event.target.value));
  }

  const handleJoin=(joinedNs)=>{
    useApi.post('ngp/namespace/user/pending/apply?namespaceId='+joinedNs.id,{
      "namespaceRoleName": "guest",
      "workspaceUserDesc": "empty"
    }).then(()=>{
      if(!requestedNs.includes(joinedNs.id))setRequestedNs([...requestedNs,joinedNs.id])
      setTimeout(() => {
        refreshNsAllList();
      }, 4000);
    })
  }

  const handleInputClear=()=>{
    setInputValue("");
    setSearchResults([]);
    setIsInputClear(false);
    setIsList(false);
  }


  return(
    <EmptyModal
    onAction={()=>{}}
    onClose={()=>onClose()}>
      <div className={styles['main']}>
        <div className={styles['header']}>
            <div className={styles['header-title']}>
                <span>Join namespace</span>
            </div>
            <div className={styles['close']}onClick={onClose}></div>
        </div>
        <div className={styles['search']}>
          <div className={styles['icon']}></div>
          <input className={styles['input']} 
          ref={input => input && input.focus()}
          value={inputValue}
          onChange={handleInputChange} 
          placeholder='Search namespace'></input>
          {isInputClear&&<div className={styles['input-clear']} onClick={handleInputClear}></div>}
        </div>
        <div className={`${styles['list']} ${isList && styles['list-on']}`}>
          <span>Results</span>
          {searchResults.map(value=>
          <div className={styles['item']}>
            <span>{value.namespaceName}</span>
            {value.status==="registered"?
              <div className={styles['item-label']}>{toUpperFirstCase(value.namespaceUserRoleName)}</div>
              :value.namespaceUserRoleName?
                <div className={styles['item-label']}>Requesting</div>
                :<div className={`${styles['item-btn']} ${requestedNs.includes(value.id)&&styles['item-btn-on']}`} onClick={()=>handleJoin(value)}>{requestedNs.includes(value.id)?"Requesting":"Join Request"}</div>
            }
          </div>
          )}
        </div>
      </div>
    </EmptyModal>
  )
}